import _ from 'lodash'
import React, { useEffect, useState } from 'react'
import { currency, deepCopy, format } from '../services/common.service'
import { MultiSelect } from 'react-multi-select-component'
import * as R from 'ramda';
let filterOptions: any = []

export const TableFilterComponent = ({ columnData, rowData, setFilteredData, initiateSearch }: any) => {

    const [
        filters,
        setFilters
    ] = useState<any>([
        {
            FieldName: '',
            FilterOperatorId: 0,
            FieldValue: null,
            FieldType: 'text'
        }
    ]);
    const [selectedField, setSelectedField] = useState([]);
    const [filterType, setFilterType] = useState([])
    const [selectedDateField, setSelectedDateField] = useState('')
    // const [filteredFields, setFilteredFields] = useState<any>();
    // const [filteredData, setFilteredData] = useState<any>(rowData);
	const [searchTerm, setSearchTerm] = useState<string>("");
	const [searchColumn, setSearchColumn] = useState<string>("");


    useEffect(() => {
        console.log('columnData changing', columnData)
        const filteredFields = (_.filter(
            columnData,
            (item) => item.field !== 'Sl' && item.field !== 'Edit' && item.filter
        ))

        if (filteredFields) {
            const filteredDataList: any[] = []
            R.map((data: any) => {

                filteredDataList.push({
                    label: data?.headerName,
                    value: data?.field
                })
                return data;
            })(filteredFields)

            filterOptions = filteredDataList
        }

        console.log("filteredFields", filteredFields)
    }, [columnData]);


    useEffect(() => {
        console.log(selectedField, 9999)
        const newdata: any = [...filterType, "string"]

        setFilterType(newdata)

    }, [selectedField])

    const handleFilterType = (e: any, idx: any) => {
        let arr: any = []
        filterType.map((obj: any, index: any) => {
            if (idx == index) {
                arr.push(e.target.value)
            }
            else {
                arr.push(obj)
            }
        })
        console.log(arr)
        setFilterType(arr)
    }

    // useEffect(() => {
    //     console.log('filteredFields changing', filteredFields)
    //     if (filteredFields) {
    //         const filteredDataList: any[] = []
    //         R.map((data: any) => {

    //             filteredDataList.push({
    //                 label: data?.headerName,
    //                 value: data?.filteredField
    //             })
    //             return data;
    //         })(filteredFields)

    //         filterOptions = filteredDataList
    //     }

    // }, [filteredFields])

    const resetFilter = () => {
        setFilters([]);
        setFilteredData(rowData);
    }

    const handleFilter = () => {
        console.log("Filter config", "selectedField", selectedField, "filters", filters)

        const selectedFilters = _.map(filters, (filter: any) => { return ({ key: filter.FieldName, type: filter.FieldType }) })
        console.log('selectedFilters', selectedFilters)

        function getValueByPath(obj: any, keyPath: string[]): any {
            return keyPath.reduce((acc, key) => (acc && acc[key] !== undefined) ? acc[key] : undefined, obj);
        }


        const filteredData = rowData.filter((item: any) => {
            return selectedFilters.every(({ key, type }) => {
                const filterValue = _.find(filters, ["FieldName", key])?.FieldValue;
                console.log('Matching key value', key, filterValue, type)
                console.log('checking item', item)
                if (!filterValue) return true;
                const keyPath = key.split('.');
                const value = getValueByPath(item, keyPath);
                switch (type) {
                    case 'text':
                    case 'string':
                        return String(value).toLowerCase().includes(String(filterValue).toLowerCase());
                    case 'number':
                        return Number(value) === Number(filterValue);
                    case 'date':
                    case 'datetime':
                        return String(value).startsWith(String(filterValue));
                    case 'boolean':
                        return value === (filterValue === 'true');                        
                    default:
                        return true;
                }
            });
        });
        console.log('rowData', rowData)
        console.log('filteredData', filteredData)
        setFilteredData(filteredData)
    }

    const onFieldValueChange = (value: any, field: any, idx: any, fieldName: any, type: string) => {
        console.log('field', field, 'value', value, 'idx', idx, 'fieldName', fieldName, "type", type)
        console.log('filters', filters)
        const filtersCopy: any = deepCopy(filters)

        if (filtersCopy?.length < idx + 1) {
            filtersCopy.push({
                FieldName: '',
                FilterOperatorId: 0,
                FieldValue: null,
                FieldType: 'text'
            })
        }
        filtersCopy[idx].FieldName = field.value
        filtersCopy[idx].FieldValue = value
        filtersCopy[idx].FieldType = type
        setFilters(filtersCopy)
    }

    const removeFilter = (itemIndex: number) => {        
        const newArray = selectedField.filter((_, index) => index !== itemIndex);
        setSelectedField(newArray)
    }
    return (

        <>
            
                {/* Filter Section */}
                <div className="h-full p-2 bg-white shadow-lg rounded-lg space-y-6 overflow-y-auto z-[99999]">
                    <div className="flex flex-row items-center space-x-4 p-2 bg-gray-100 rounded-lg shadow-md">
                        {/* Search Bar */}
                        <div key="search-bar-1" className="flex flex-col items-center relative w-full">
                            <div className="flex self-start w-full py-2">
                                <select className={`bg-white text-primary p-2 h-10`}
                                 onChange={(e) => setSearchColumn(e.target.value)}
                                >
                                    <option selected>All</option>
                                    {columnData?.map(
                                        (column: any, index: any) => (
                                            column.searchField && <option>{column?.searchField}</option>
                                        ))
                                    }
                                </select>
                            </div>    
                            <div className="flex items-center relative w-full">                      
                                <input
                                    type="search"
                                    name="search"
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                    placeholder="Search products..."
                                    className="bg-white h-10 w-full px-5 pr-10 rounded-lg border border-gray-300 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition duration-200 ease-in-out shadow-sm"
                                />
                                <button
                                    type="button"
                                    onClick={() => initiateSearch({
                                        column: searchColumn,
                                        value: searchTerm                                        
                                    })}
                                    className="absolute right-3 top-1/2 transform -translate-y-1/2"
                                >
                                    <svg
                                        className="h-5 w-5 text-gray-600"
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 56.966 56.966"
                                        fill="currentColor"
                                    >
                                        <path d="M55.146,51.887L41.588,37.786c3.486-4.144,5.396-9.358,5.396-14.786c0-12.682-10.318-23-23-23s-23,10.318-23,23  s10.318,23,23,23c4.761,0,9.298-1.436,13.177-4.162l13.661,14.208c0.571,0.593,1.339,0.92,2.162,0.92  c0.779,0,1.518-0.297,2.079-0.837C56.255,54.982,56.293,53.08,55.146,51.887z M23.984,6c9.374,0,17,7.626,17,17s-7.626,17-17,17  s-17-7.626-17-17S14.61,6,23.984,6z" />
                                    </svg>
                                </button>
                            </div>  
                        </div>
                    </div>
                    <div>
                        {/* Filter By */}
                        <div className="flex flex-col justify-start items-center">
                            <span className="text-md font-semibold text-gray-700 self-start">Filter By</span>

                            {/* MultiSelect Dropdown */}
                            <div className="w-full">
                                <MultiSelect
                                    options={filterOptions}
                                    value={selectedField}
                                    onChange={setSelectedField}
                                    labelledBy="Select"
                                    className="rounded-lg border border-gray-300 bg-white text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 shadow-sm"
                                />
                            </div>
                        </div>
                        <div className="flex flex-col justify-start items-center py-2">
                            <div className="flex w-full justify-end items-center space-x-2">
                                <button
                                    onClick={()=>{resetFilter()}}
                                    className="flex items-center h-8 px-4 bg-blue-600 text-white rounded-lg text-sm font-medium hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 transition duration-200"
                                >
                                    <svg className="h-5 w-5 mr-2" viewBox="0 0 24 24" fill="none">
                                        <path d="M20.9843 5C21.0344 4.28926 20.9732 3.83888 20.672 3.5074C20.2111 3 19.396 3 17.7657 3H6.23433C4.60404 3 3.7889 3 3.32795 3.5074C2.86701 4.0148 2.96811 4.8008 3.17033 6.3728C3.22938 6.8319 3.3276 7.09253 3.62734 7.44867C4.59564 8.59915 6.36901 10.6456 8.85746 12.5061C9.08486 12.6761 9.23409 12.9539 9.25927 13.2614C9.53961 16.6864 9.79643 19.0261 9.93278 20.1778C10.0043 20.782 10.6741 21.2466 11.226 20.8563C12.1532 20.2006 13.8853 19.4657 14.1141 18.2442C14.1986 17.7934 14.3136 17.0803 14.445 16" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M15.0132 6L14.5139 8.08437L15.3434 7.56607C15.9343 7.11729 16.6687 6.85119 17.4646 6.85119C19.4172 6.85119 21 8.45151 21 10.4256C21 12.3997 19.4172 14 17.4646 14C15.7543 14 14.3276 12.772 14 11.1405" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                    Clear                                
                                </button>   
                                <button
                                    onClick={handleFilter}
                                    className="flex items-center h-8 px-4 bg-blue-600 text-white rounded-lg text-sm font-medium hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 transition duration-200"
                                >
                                    <svg className="h-5 w-5 mr-2" viewBox="0 0 24 24" fill="none">
                                        <path d="M8.85746 12.5061C6.36901 10.6456 4.59564 8.59915 3.62734 7.44867C3.3276 7.09253 3.22938 6.8319 3.17033 6.3728C2.96811 4.8008 2.86701 4.0148 3.32795 3.5074C3.7889 3 4.60404 3 6.23433 3H17.7657C19.396 3 20.2111 3 20.672 3.5074C21.133 4.0148 21.0319 4.8008 20.8297 6.37281C20.7706 6.83191 20.6724 7.09254 20.3726 7.44867C19.403 8.60062 17.6261 10.6507 15.1326 12.5135C14.907 12.6821 14.7583 12.9567 14.7307 13.2614C14.4837 15.992 14.2559 17.4876 14.1141 18.2442C13.8853 19.4657 12.1532 20.2006 11.226 20.8563C10.6741 21.2466 10.0043 20.782 9.93278 20.1778C9.79643 19.0261 9.53961 16.6864 9.25927 13.2614C9.23409 12.9539 9.08486 12.6761 8.85746 12.5061Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                    Filter
                                </button>                                                             
                            </div>
                            
                        </div>

                        
                    </div>

                    {/* Dynamic Filter Fields */}
                    <div className="space-y-4">
                        {selectedField.map((item: any, index: any) => (
                            console.log('Check column', item.value, _.find(columnData, (o)=>{ return o.field === item.value} )),
                            // console.log('Get: ', _.get( _.find(columnData, { field: item.value }), 'filterBy', [])),
                            <div key={index} className="w-full bg-white rounded-lg shadow-md">
                                <div className="flex justify-between items-center px-2 py-1 bg-gray-50 rounded-lg">
                                    {/* Label */}
                                    <div className="w-5/12 p-2 text-sm text-gray-700">{item?.label}</div>
                                    {/* Input or Select based on filter type */}
                                    
                                    <div className="w-5/12">                                        
                                        { 
                                        
                                        _.isEmpty(_.get( _.find(columnData, { field: item.value }), 'filterBy', []))? (
                                            console.log('columnData',_.find(columnData, (o)=>{ return o.field === item.value} )?.filterType),
                                            <input
                                            type={`${_.find(columnData, (o) => o.field === item.value)?.filterType || 'text'}`}
                                            onChange={(event: any) => onFieldValueChange(
                                                event.target.value,
                                                item,
                                                index,
                                                item?.label,
                                                `${_.find(columnData, (o) => o.field === item.value)?.filterType || 'text'}`
                                                // filterTypeLists[index]?.value
                                            )}
                                            placeholder="Enter value"
                                            className="h-8 w-full px-3 border border-gray-300 rounded-lg text-gray-700 focus:ring-2 focus:ring-blue-500 transition duration-200"
                                        />                                           
                                        ) : (
                                            <select
                                                className="h-8 w-full border border-gray-300 rounded-lg bg-white px-3 text-gray-700 focus:ring-2 focus:ring-blue-500 transition duration-200"
                                                // onChange={(event) =>
                                                //     onFieldValueChange(event.target.value, item, index, item?.label,)
                                                // }
                                                // value={filterValues[index]}
                                            >
                                                {columnData.map((column: any) => (
                                                    // console.log('column', column, item),
                                                    column.field && item.value &&
                                                    column?.filterBy?.map((option: any) => (
                                                        console.log('option', option),
                                                    <option key={option?.value} value={option?.Value}>
                                                        {option?.Text}
                                                    </option>
                                                    
                                                ))))}
                                            </select>
                                        )}
                                        
                                    </div>

                                    {/* Delete Filter Button */}
                                    <div className="flex justify-end items-center ml-2 w-1/6">
                                        <button onClick={() => removeFilter(index)}>
                                            <svg
                                                className="h-5 w-5 text-gray-500 hover:text-red-500"
                                                xmlns="http://www.w3.org/2000/svg"
                                                fill="none"
                                                viewBox="0 0 24 24"
                                                stroke="currentColor"
                                            >
                                                <path
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    strokeWidth="2"
                                                    d="M6 18L18 6M6 6l12 12"
                                                />
                                            </svg>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>           
        </>


    )
}
